RivalIQ.apps.Discovery.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const TableView = RivalIQ.apps.Dashboard.widgets.MetricTable.mixin({

        mixins: {
            LoadDataWithBuffering: RivalIQ.apps.Dashboard.mixins.LoadDataWithBuffering
        },

        ui: _.defaults({
            influencer: '.author-name',
            tooltips: '[data-toggle="tooltip"]'
        }, RivalIQ.apps.Dashboard.widgets.MetricTable.prototype.ui),

        rowClassName: 'discovery-table-row',

        _loadData: function () {
            const me = this;

            return RivalIQ.apps.Dashboard.widgets.MetricTable.prototype.loadData.call(me);
        },

        _generateRowData: function () {
            const me = this;
            RivalIQ.apps.Dashboard.widgets.MetricTable.prototype._generateRowData.call(me);

            const limit = me.getProp('limit');
            if (limit > 0) {
                me.rows = _.take(me.rows, limit);
                me.dimensionRows = _.take(me.dimensionRows, limit);
            }
        },

        getFetchAttributes: function () {
            const me = this;

            const orderBy = me.getProp('orderBy');
            me.sortColumns = App.utils.getColumnSortOrder(me.metricsCollection, orderBy);

            return {
                limit: Number(me.getProp('limit') || 0),
                sortOrder: Number(me.getProp('sortOrder') || 1),
                orderBy: App.utils.getOrderByString(me.sortColumns, me.metricsCollection)
            };
        },

        onRender: function () {
            const me = this;
            me.ui.tooltips.tooltip();

            const influencers = _.reduce(me.rows, function (memo, row) {
                const user = _.last(row[0]);
                memo[user.handle] = user;

                return memo;
            }, {});

            App.views.InfluencerPopover.addPopovers(me, me.ui.influencer, influencers);
        },

        onRowClick: function (data, e) {
            const me = this;

            const target = $(e.target);

            if (target.hasClass('x-view-posts')) {
                const user = _.get(data, [0, 1]);
                const modalProps = _.defaults({
                    postAuthorFilters: [user.handle]
                }, me.getProps());
                App.views.PostsModal.show(modalProps);
                e.preventDefault();
            } else if (target.hasClass('x-filter-results') || target.parents('.x-filter-results').length > 0) {
                App.utils.trackFilterLinkClick(target, me);
            }
        }
    });

    const DiscoveryInfluencerTableWidget = widgets.DiscoveryInfluencerTableWidget = RivalIQ.apps.Dashboard.widgets.TableWidget.extend({
        view: TableView,
        footerView: RivalIQ.apps.Dashboard.views.PanelFooter,

        title: 'Influencers',

        description: function () {
            const me = this;
            return RivalIQ.strings[`discovery_${me.getProp('channel')}_influencers_description`];
        },

        neverFilter: true,

        getFilename: App.utils.getExportFilename,
        getExportTitle: App.utils.exportTitle,
        getExportSubtitle: App.utils.exportSubtitle,
        getPptSubtitle: App.utils.pptSubtitle,

        tableClassName: 'table-hover',

        processProps: function (props) {
            const me = this;

            me.metric = RivalIQ.metric.build(props, _.clone(me.baseMetric));

            props = _.defaults(props, {
                limit: 5,
                orderBy: 5, // sort by influencer score
                sortOrder: 1, // descending
                showDescriptions: true
            });

            const metrics = RivalIQ.metric.build(me.metric, [
                {
                    property: 'influencer',
                    name: 'Profile Overview',
                    cellView: _.constant(App.views.InfluencerProfileTableCell),
                    sortable: false
                },
                {
                    property: 'avg_engagement_rate_per_post',
                    cellView: false
                },
                {
                    property: 'presence_reach'
                },
                {
                    property: 'presence_following',
                    name: 'Following'
                },
                {
                    property: 'relevant_posts',
                    name: 'Relevant Posts'
                },
                {
                    property: 'influencer_score',
                    cellView: _.constant(App.views.InfluencerScoreTableCell)
                }
            ]);

            me.metricsCollection = new RivalIQ.collections.MetricDefinitions(metrics);

            const parentFn = RivalIQ.apps.Dashboard.widgets.TableWidget.prototype.processProps;
            return parentFn.apply(me, arguments);
        },

        csvExportProps: function () {
            const me = this;

            return {
                type: 'discoveryDataGenerator',
                metric: me.getExportMetricDefinitions('csv'),
                includeDimensionColumn: false
            };
        },

        getExportMetricDefinitions: function (format) {
            const me = this;

            // NOTE we are overriding a particular column serializer to expand into several columns for CSV
            const compoundMetric = me.metricsCollection.findWhere({
                property: 'influencer'
            });
            const defaultSerializer = compoundMetric.serialize;

            compoundMetric.serialize = function (format) {
                if (format === RivalIQ.enums.exportFormat.CSV) {

                    // NOTE we have verified for twitter but not for instagram
                    const isTwitter = (me.getProp('channel') === RivalIQ.enums.channels.TWITTER);
                    const expandedMetricSet = _.compact([
                        compoundMetric.build({
                            property: 'handle',
                            name: 'Handle'
                        }),
                        compoundMetric.build({
                            property: 'full_name',
                            name: 'Full Name'
                        }),
                        (isTwitter ? compoundMetric.build({
                            property: 'verified',
                            name: 'Verified'
                        }) : null),
                        compoundMetric.build({
                            property: 'overview',
                            name: 'Overview'
                        }),
                        compoundMetric.build({
                            property: 'icon_url',
                            name: 'Icon URL'
                        })
                    ]);

                    return _.invokeMap(expandedMetricSet, 'serialize', format);
                } else {
                    return defaultSerializer.apply(compoundMetric, arguments);
                }
            };

            // NOTE flatten the nested metrics that get inserted via the serializer above
            const metrics = _.flatten(me.metricsCollection.invoke('serialize', format));

            const sortColumns = me.metricsCollection.getColumnSortOrder(me.getProp('orderBy'));
            const orderBy = me.metricsCollection.getOrderBy(sortColumns);

            return _.map(metrics, function (metric) {
                return _.extend(metric, {
                    orderBy: orderBy,
                    limit: -1
                });
            });
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.DISCOVERY_INFLUENCER_TABLE, DiscoveryInfluencerTableWidget);

});
